<!--
 * @Description: 表后设施检漏申请
--> 
<template>
  <div class="meter-transfer-form">
    <van-nav-bar
      left-text="返回"
      :title="$route.meta.title"
      @click-left="$comm.onClickLeft"
      left-arrow
      fixed
      >
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <van-form @submit="onSubmit">
      <van-field
        clickable
        v-model="form.userno"
        label="用户号"
        placeholder="请选择用户号"
      >
        <template v-if="!$route.query.readonly" #button>
          <van-button class="comm-small-btn" native-type="button" @click="choiceClick()">选择</van-button>
        </template>
      </van-field>
      <van-field
        required
        v-model="form.uname"
        label="用户名/申请人"
        placeholder="用户名/申请人"
        :rules="[{ required: true, message: '请输入用户名/申请人' }]"
      />
      <van-field
        required
        v-model="form.addr"
        label="地址"
        placeholder="地址"
        :rules="[{ required: true, message: '请输入地址' }]"
      />
      <van-field
        required
        v-model="form.tel"
        label="联系电话"
        placeholder="联系电话"
        :rules="[{ pattern: $pattern, message: '请输入正确格式' }]"
      />
      <van-field
        required
        v-model="form.idenno"
        label="身份证号/税号"
        placeholder="身份证号/税号"
        :rules="[{ required: true, message: '身份证/税号' }]"
      />
      <van-field
        v-model="form.operator"
        label="联系人"
        placeholder="联系人"
      />
      <van-field
        v-model="form.opmobile"
        name="validator"
        label="联系人手机"
        placeholder="联系人手机"
        :rules="[{ validator: $comm.validator, message: '请输入正确格式' }]"
      />
      <van-field
        readonly
        clickable
        name="datetimePicker"
        v-model="form.appointment"
        label="预约日期"
        placeholder="点击选择预约日期"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-datetime-picker
          type="date"
          title="选择年月日"
          :min-date="$currentDate"
          :max-date="$maxDate"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        v-model="form.remark"
        rows="2"
        autosize
        label="备注"
        type="textarea"
        maxlength="500"
        placeholder="请填写备注"
        show-word-limit
      />
      <div class="comm-form-group">资料上传</div>
      <van-field
        name="uploaderZero"
        :rules="[{ required: true, message: '请上传资料' }]"
        >
        <template #input>
          <van-uploader
            :deletable="!$route.query.readonly"
            :show-upload="!$route.query.readonly"
            multiple
            v-model="uploaderZero"
            :after-read="afterReadMaster"
            @delete="onDeleteMaster"
            />
        </template>
      </van-field>
      <div v-if="!$route.query.readonly" style="margin:17px 16px;margin-bottom:36.5px;">
        <van-button
          type="info"
          color="#1677FF"
          size="large"
          style="height:44px;"
          native-type="submit"
          >
          确认提交
        </van-button>
      </div>
    </van-form>
    <van-popup
      v-model="popShow"
      class="form-pop"
      >
      <user-select-pop :userList="userList" @onSelectClick="onSelectClick"></user-select-pop>
    </van-popup>
  </div>
</template>

<script>
import UserSelectPop from '@/components/UserSelectPop.vue'
export default {
  name: 'LeakForm',
  components: {
    UserSelectPop
  },
  data() {
    let cuser_info = null
    if(localStorage.getItem('cuser_info')){
      cuser_info = JSON.parse(localStorage.getItem('cuser_info'))
    }
    return {
      popShow: false,
      // zeroUrls: [{ url: 'https://img.yzcdn.cn/vant/leaf.jpg' }],
      uploaderZero: [], // vant自带缩略图站位
      zeroUrls: [],
      message: '',
      radio: '1',
      form: {
        userno: '', // 用户编号
        uname: '', // 用户名/申请人
        addr: '', // 报修地址
        tel: '', // 联系电话
        idenno: '',
        operator: cuser_info?cuser_info.uname:'',
        opmobile: cuser_info?cuser_info.mobile:'',
        appointment: '',
        remark: '', // 报修内容
        attach: []
      },
      disabled: false,
      mytime: 60000,
      value: '',
      showPicker: false,
      userList: JSON.parse(localStorage.getItem('userList'))
    }
  },
  mounted() {
    if(this.$route.query.busscode&&this.$route.query.bussno){
      this.$comm.getBussInfo(this.$route.query.busscode, this.$route.query.bussno).then(res => {
        this.form = res
        let result = this.$comm.analysisAttach(res)
        this.uploaderZero = result.uploaderZero
        this.zeroUrls = result.zeroUrls
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'ButlerProgress') {
      to.meta.isUseCache = true
    }
    next()
  },
  methods: {
    onConfirm(time) {
      // eslint-disable-next-line no-undef
      this.form.appointment = moment(time).format("YYYY-MM-DD");
      this.showPicker = false;
    },
    afterReadMaster (file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileUpload, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.zeroUrls.push(res.data)
        } else {
          this.$toast('上传失败')
        }
      })
    },
    onDeleteMaster (file, detail) {
      this.zeroUrls.splice(detail.index, 1)
    },
    onSelectClick (user) {
      this.popShow = false
      this.form.userno = user.userno
      this.form.uname = user.uname
      // this.form.addrold = user.addr
      // this.form.addr = user.fixaddr
      this.$comm.getUserInfo(this.form.userno).then(res=>{
        this.form.addr = res.zbwz
      })
    },
    choiceClick () {
      this.popShow = true
    },
    onSubmit() {
      let typeCode = this.$menuDict[this.$route.meta.title].typeCode
      this.form.attach = this.$comm.getAttach([], [], [], this.zeroUrls)
      this.$http.post(this.$api.serviceLeak, this.form).then(res => {
        if (res.code==='000') {
          this.$router.push({
            path: '/business/success',
            query: {
              title: this.$route.meta.title,
              typeCode: typeCode
            }
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    getAttachDict (attachUrls, typeId) {
      let attachDict = {}
      attachDict['typeid'] = typeId
      let attachUrl = ''
      for(let i=0;i<attachUrls.length;i++){
        if (i>0) {
          attachUrl = attachUrl + ',' + attachUrls[i].url
        } else{
          attachUrl = attachUrls[i].url
        }
      }
      attachDict['url'] = attachUrl
      return attachDict
    },
  },
}
</script>

<style lang="less" scoped>
.meter-transfer-form{
  .form-pop{
    width:85%;
    height:60%;
    border-radius:4px;
    font-size:12px;
    .user-list{
      background:rgba(255,255,255,1);
      padding: 21px 16px;
    }
  }
}
</style>